module.exports = __webpack_public_path__ + "img/6.33bf04ec.jpg";